import { Vec3 } from 'vec3';
export declare const player: (player: Player) => void;
export declare const entity: (entity: Entity, serv: Server) => void;
declare global {
    interface Player {
    }
    interface Entity {
        /** ID of entity on server */
        id: string;
        /** Current position (currently in fixed position (x32 what you'd expect) so do entity.position.scaled(1/32) to get normal position) */
        position: Vec3;
        /** Used to calculate collisions for server-side entities */
        size: Vec3;
        /** Yaw of entity (rotation looking up and down) */
        yaw: number;
        /** Pitch of entity (rotation sideways) */
        pitch: number;
    }
}
